import { render, staticRenderFns } from "./Music2Icon.vue?vue&type=template&id=294a1a5e"
import script from "./Music2Icon.vue?vue&type=script&lang=js"
export * from "./Music2Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports